export const InputStyle = {
  width: '100%',
  borderRadius: '9px',
  background: '#F9F9F9',
  '& label.Mui-focused': {
    color: '#505259',
    borderRadius: '7px',
  },
  '& input': {
    padding: '12px',
    fontSize: '19px',
    fontWeight: '400',
    '&::placeholder': {
      paddingLeft: '0!important',
    },
  },
  '& input::placeholder': {
    padding: '12px',
    fontSize: '19px',
    fontWeight: '400',
  },
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      borderColor: '#F9F9F9',
      borderRadius: '7px',
    },
    '&.Mui-focused fieldset': {
      borderRadius: '7px',
      borderWidth: '1px',
      borderColor: '#eee',
      borderStyle: 'solid',
    },
  },
  '&.addPhoneFormInputWrapper .Mui-error .MuiOutlinedInput-notchedOutline': {
    borderColor: '#FF0F23',
  },
};

export const SelectStyle = {
  '& .Mui-selected': {
    background: '#00000000',
  },
  '& .MuiInputBase-input': {
    paddingLeft: '5px',
    border: 'none',
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderWidth: '0px',
  },
  '& .MuiInputBase-formControl': {
    borderRadius: '0px',
  },
  '& fieldset': {
    borderColor: '#00000000 !important',
  },
  '& .Mui-focused fieldset': {
    borderColor: '#00000000 !important',
  },
};

export const btnRedDisabled = {
  color: '#fff',
  width: '48%',
  height: '40px',
  fontSize: '16px',
  margin: '5px 0',
  textTransform: 'none',
  background: '#CC0C1C',
  boxShadow: 'none',
  '&:hover': {
    backgroundColor: '#FF475D',
  },
  '&.Mui-disabled': {
    backgroundColor: '#FF9FA7',
    color: '#fff',
  },
};
export const btnCancelDisabled = {
  width: '48%',
  height: '40px',
  margin: '5px 0',
  fontSize: '16px',
  color: '#1a1a1a',
  textTransform: 'none',
  backgroundColor: '#fff',
  border: '1px solid #888B94',
  '&:hover': {
    backgroundColor: '#efefef',
  },
  '&.Mui-disabled': {
    color: '#C2C4CC',
    backgroundColor: '#fff',
    border: '1px solid #C2C4CC',
  },
};

const ITEM_HEIGHT = 38;
const ITEM_PADDING_TOP = 8;
export const MenuProps = {
  anchorOrigin: {
    vertical: 'bottom',
    horizontal: 'left',
  },
  transformOrigin: {
    vertical: 'top',
    horizontal: 'left',
  },
  getcontentanchorel: null, // 确保菜单从顶部对齐
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
    },
    sx: {
      width: '462px',
      '& .Mui-selected': {
        backgroundColor: '#F9F9F9 !important',
      },
      '::-webkit-scrollbar': { width: '0 !important' },
      '& .MuiMenuItem-root': {
        height: '38px',
        fontSize: '14px',
        lineHeight: '38px',
        color: '#333',
        fontWeight: '400',
        borderBottom: '1px solid #eee',
      },
    },
  },
};

export const pwdBtnStyle = {
  width: '100%',
  height: '48px',
  fontSize: '20px',
  margin: '5px 0',
  color: '#fff', // 自定义文字颜色
  backgroundColor: '#CC0C1C', // 自定义背景颜色
  textTransform: 'none',
  boxShadow: 'none',
  '&:hover': {
    backgroundColor: '#FF475D', // 悬停时的背景颜色
  },
  '&.Mui-disabled': {
    backgroundColor: '#FF9FA7',
    color: '#fff',
  },
};

export const emailInputStyle = {
  '& .MuiFormLabel-root': {
    padding: '0',
    backgroundColor: '#FFF !important',
    lineHeight: '20px',
    '&.Mui-focused': { color: '#505259' },
  },
  '& .MuiOutlinedInput-root': {
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: '#1A1A1A', // 聚焦时的边框颜色
      borderWidth: '1px',
    },
  },
  '& label[data-shrink="true"]': {
    top: '2px',
    padding: '0 4px',
  },
  '& label[data-shrink="false"]': {
    top: '-2px',
  },
  '& label.Mui-error': {
    color: '#FF0F23!important',
  },
  '& .Mui-error .MuiOutlinedInput-notchedOutline': {
    borderColor: '#FF0F23!important',
  },
};
export const passwordStyle = {
  '& .MuiFormLabel-root': {
    padding: '0',
    backgroundColor: '#FFF !important',
    lineHeight: '20px',
    '&.Mui-focused': { color: '#505259' },
  },
  '& .MuiOutlinedInput-root': {
    height: '48px',
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: '#1A1A1A', // 聚焦时的边框颜色
      borderWidth: '1px',
    },
  },
};
